import { createContext, type FC } from 'react'

/**
 * Optional override for the avatar rendered next to a comment authored by
 * `userId === 'assistant'`. Set by host wrappers that know the assistant's
 * identity (e.g. `AgentChat` in `@tunasong/plugin-agent`) so per-agent
 * icon + color render in the chat feed instead of the generic dummy avatar.
 *
 * `null` means "no override" — `ChatFeedItem` falls back to the dummy
 * avatar in that case. The component contract is the same as the existing
 * `UserIcon` slot on `ChatItem`: a parameterless React component.
 *
 * The context lives in plugin-chat (and is provided by plugin-agent) to
 * keep the dependency direction one-way; plugin-chat cannot import from
 * plugin-agent because plugin-agent already depends on plugin-chat.
 */
export const AssistantAvatarContext = createContext<FC | null>(null)

/**
 * Optional override for the name shown above an assistant comment, set alongside `AssistantAvatarContext`
 * by `AgentChat`: the agent's own display name, so a band's "Nils" is labelled Nils in its thread rather
 * than the generic assistant profile's name (Personalize agents, Joni's review of #2473). `null` keeps the
 * assistant profile's name.
 */
export const AssistantNameContext = createContext<string | null>(null)
